<template>
  <span class="is-size-7 has-text-success is-tooltip-bottom"
        :class="{'has-text-success': value >= 0, 'has-text-danger': value < 0, 'tooltip': tooltipContent !== '' }"
        :data-tooltip="tooltipContent">
    <i v-if="value > 0" class="fas fa-caret-up"></i>
    <i v-else class="fas fa-caret-down"></i>
    &nbsp;
    {{ value | round(2) }}
    <span v-if="suffix">{{ suffix }}</span>
  </span>
</template>

<script>
  export default {
    name: 'VariationIndice',
    props: {
      newValue: {
        type: [Number, String],
        required: true
      },
      oldValue: {
        type: [Number, String],
        required: true
      },
      suffix: {
        type: String,
        required: false,
        default: '%'
      },
      tooltipContent: {
        type: String,
        required: false,
        default: ''
      }
    },
    computed: {
      xtooltipContent () {
        return 'Période précedente : ' + this.oldValue.toLocaleString()
      },
      value () {
        if (this.newValue === 0 || this.oldValue === 0) {
          return null
        }
        let delta = (this.newValue - this.oldValue) / this.oldValue
        delta = delta * 100
        return delta
      },
      faClass () {
        if (this.value >= 0) {
          return 'fa-caret-up'
        } else {
          return 'fa-caret-down'
        }
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/utils/VariationIndice.vue